var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Revoke User Privileges ")]
          ),
          _vm.user && _vm.database
            ? _c("v-card-text", [
                _c(
                  "p",
                  {
                    staticClass: "mb-0"
                  },
                  [
                    _vm._v(
                      " Are you sure you wish to revoke privileges for “" +
                        _vm._s(_vm.user) +
                        "” from the database “" +
                        _vm._s(_vm.database) +
                        "”? "
                    )
                  ]
                )
              ])
            : _vm._e(),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.revoke
                  }
                },
                [_vm._v(" Revoke ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }